<template>
  <div>
      	<div class="form-group" :class="{'input-disabled': provider_data.shift_blocking_disabled}">
          <!--  -->
					<input id="shift_blocking" type="checkbox"  @click="deneme" v-model="provider_data.shift_blocking_disabled"/>
							<label for="shift_blocking" style="width:auto; font-size: 13px; font-weight: bold;">  Enable access to training during shift hours</label>
				</div>
          <b-modal no-close-on-backdrop hide-header v-model="show_modal" @ok="ShiftBlockingAction"  @cancel="undoShiftBlocking" cancel-title="Cancel" ok-title="Enable">
            <p>
              {{provider_data.first_name}} will be able to access training during shift hours until 11:59 p.m. today. This action cannot be undone.
            Access to training during shift hours will be disabled again after 12:00 a.m.
            </p>
          </b-modal>
  </div>
</template>
<script>
export default {
  props:{
    provider_data:{
      required:true
    },
    organization_id:{
      required: false
    }
  },
  computed:{
    // getUserStatus(){
    //   return this.$store.getters.getRole
    // }

  },
  data: function(){
    return{
      show_modal: false,
    }
  },
  methods:{
    ShiftBlockingAction: function(){
      let params = {
        id: this.organization_id || this.provider_data.organization.id,
        provider_id: this.provider_data.id
      }
      this.$store.dispatch('shiftBlockingDisabled', params).then((res) => {
			}).catch((error) =>{
				console.log(error);
			});


    },
    deneme: function(){
      this.show_modal = !this.show_modal
    },
    undoShiftBlocking: function(){
      console.log("here??")
      this.provider_data.shift_blocking_disabled = false
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/inputs/ShiftBlockingView.vue